import React, { useEffect } from 'react'
import { slugs } from '../../../Constant/slugs';
import { Link, Redirect, useLocation, redirect, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { CustomButton } from '../../CustomButtom';
import ImageUpload from '../../ImageUpload';
import { AdsPUTApi, NodePOSTApi, NodePUTApi } from '../../../Constant/api';
import NotFound from '../../NotFound';
import axios from 'axios';

export default function CoursePayment(props) {
  const location = useLocation()
  const Login = useSelector((state) => state.LoginState);
  const [reload, setReload] = React.useState(true)
  const [CoursePrice, setCoursePrice] = React.useState("")
  const [PhoneNumber, setPhoneNumber] = React.useState(Login.userPhoneNumber)
  const [Email, setEmail] = React.useState(Login.userEmail)
  const [VerificationMethod, setVerificationMethod] = React.useState("Esewa")
  const [VerificationID, setVerificationID] = React.useState("")
  const [pid, setPid] = React.useState("")
  const [BuyNow, setBuyNow] = React.useState(true)
  const [NewPayment, setNewPayment] = React.useState(true)
  const [item, setItem] = React.useState({})
  const [Results, setResults] = React.useState([])
  const [NotFoundData, setNotFound] = React.useState(false)
  const [OrderID, setOrderID] = React.useState("")
  const [KhaltiPaymentURL, setKhaltiPaymentURL] = React.useState("")
  const [ResetFreeCourse, setResetFreeCourse] = React.useState(false)
  const [ResetFreeExamID, setResetFreeExamID] = React.useState("")
  const [PreviewPressed, setPreviewPressed] = React.useState(false)
  const [PreviewUrl, setPreviewUrl] = React.useState("")
  const [PreviewType, setPreviewType] = React.useState("")
  var ExamPrice = ""
  const history = useHistory()
  const CustomButton = ({ setData, Data, DataValue, ImageUrl }) => {
    return (
      <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
        onClick={() => {
          setData(DataValue)
        }}
      >
        <div className={Data == DataValue ? "active-option" : "passive-option"}>
          {ImageUrl !== "" ?
            <img src={ImageUrl} style={{ width: "100px", height: "30px", objectFit: "cover" }} />
            :
            <span style={{ width: "100px", height: "30px", }}>
              {DataValue}
            </span>
          }
        </div>
      </button>
    )
  }
  const [OrderData, setOrderData] = React.useState([])
  useEffect(() => {
    fetchCourse(location.pathname.slice(slugs.course_payment.length + 1))
    window.scrollTo(0, 0)
  }, [])

  const fetchCourse = (CourseID) => {
    setReload(true)
    NodePOSTApi({
      userID: Login.userID,
      examID: CourseID
    }, "course-payment-details")
      .then((res) => {
        console.log(res.data)

        setReload(false)
        if (res.data.error)
          setNotFound(true)
        else {
          console.log(1)
          setItem(res.data.exam_data[0])
          console.log(2)
          setOrderData(res.data.order_data)
          console.log(3)
          if (res.data.order_data.filter(a => a.meta.verification_status == "Verified").length !== 0) {
            console.log(4)
            setCoursePrice(0)
          }
          else {
            setCoursePrice(res.data.exam_data[0].meta.course_price)
            console.log(5)
          }
        }
      })
      .catch(err => {
        setNotFound(true)
        console.log(err)
        console.log(err.response)
      })
  }
  const myform = React.useRef(null)
  function generateRandomNumber() {
    var minm = 1000;
    var maxm = 9999;
    return Math.floor(Math.random() * (maxm - minm + 1)) + minm;
  }
  const BuyExamHandle = () => {
    const NewReset = OrderData.filter(a => a.meta.verification_status == "Verified").length == 0 ? "" : "1"
    var data;
    data = {
      "title": `${Login.userID}-${item.id}`,
      "status": "publish",
      // "author": `${Login.userID}`,
      meta: {
        "course_name_order": item.title.rendered,
        "course_id_order": `${item.id}`,
        "student_id_order": `${Login.userID}`,
        "student_email_order": Email,
        "student_phone_order": `${PhoneNumber}`,
        "student_username_order": `${Login.userName}`,
        "paid_amount": "0",
        "amount_to_pay": `${CoursePrice}`,
        "verification_status": "Unverified",
        "verification_method": VerificationMethod,
        "verification_date": "",
        "verification_id": `${VerificationID}`,
        "new_reset": NewReset
      }
    }
    NodePOSTApi({ orderData: JSON.stringify(data) }, "buy-course")
      .then(res => {
        console.log(res.data)
        setOrderID(res.data.id)
        if (VerificationMethod == "Manual") {
          window.location.reload()
        }
        else if (VerificationMethod == "Esewa") {
          const RandNum = generateRandomNumber()
          setPid(`${res.data.id}-${RandNum}`)
          setTimeout(() => {
            localStorage.setItem("pid", `${res.data.id}-${RandNum}`)
            localStorage.setItem("AmountPaid", `${CoursePrice}`)
            myform.current.submit()
          }, 100)
        }
        else if (VerificationMethod == "MyPay") {
          MyPayPayment(res.data.id)
        }
        else {
          KhaltiPayment(res.data.id)
        }
      }
      )
  }

  const PayNowHandle = (id, verify) => {
    var data;
    const NewReset = OrderData.filter(a => a.meta.verification_status == "Verified").length == 0 ? "" : "1"
    data = {
      meta: {
        "paid_amount": "0",
        "amount_to_pay": `${verify.amount_to_pay}`,
        "verification_status": "Unverified",
        "verification_method": `${verify.verification_method}`,
        "verification_date": "",
        "verification_id": `${verify.verification_id}`,
        "new_reset": NewReset
      }
    }
    NodePUTApi({ orderData: JSON.stringify(data), id: id }, "buy-course")
      .then(res => {
        console.log(res.data)
        setOrderID(id)
        if (verify.verification_method == "Manual") {
          window.location.reload()
        }
        else if (verify.verification_method == "Esewa") {
          const RandNum = generateRandomNumber()
          setPid(`${res.data.id}-${RandNum}`)
          setTimeout(() => {
            localStorage.setItem("pid", `${res.data.id}-${RandNum}`)
            localStorage.setItem("AmountPaid", `${CoursePrice}`)
            myform.current.submit()
          }, 100)
        }
        else {
          console.log(180)
          KhaltiPayment(res.data.id)
        }
      }
      )
  }

  const KhaltiPayment = async (orderID) => {
    const RandNum = generateRandomNumber()
    setPid(`${orderID}-${RandNum}`)
    localStorage.setItem("pid", `${orderID}-${RandNum}`)
    localStorage.setItem("AmountPaid", `${CoursePrice}`)
    console.log(192)

    NodePOSTApi(
      {
        ExamPrice: `${CoursePrice}00`,
        orderID: orderID,
        RandNum: RandNum,
        item: item,
        Login: Login,
        return_url: `https://exam.dreamkoreansmartclass.com/course_payment_khalti/${orderID}/${location.pathname.slice(slugs.exam_payment.length + 1)}`
        // return_url: `http://localhost:3000/course_payment_khalti/${orderID}/${location.pathname.slice(slugs.exam_payment.length + 1)}`
      }, "khalti_payment"
    )
      .then(res => {
        console.log(res.data)
        if (!res.data.error) {
          window.location.replace(res.data.data.payment_url)
        }
      })
      .catch(err => {
        console.log(211)
      })
  }

  const MyPayPayment = async (orderID) => {
    const RandNum = generateRandomNumber()
    setPid(`${orderID}-${RandNum}`)
    localStorage.setItem("pid", `${orderID}-${RandNum}`)
    localStorage.setItem("AmountPaid", `${ExamPrice}`)

  }

  const ResetCourseComp = () => {
    var resetCourseID;
    if (Results.filter(a => a.status == "publish").length !== 0) {
      resetCourseID = Results.filter(a => a.status == "publish")[0].id
      setReload(true)
      AdsPUTApi({
        status: "draft"
      }, "paid_results", resetCourseID)
        .then(res => {
          window.location.reload()
        })
        .finally(() => {
          setReload(false)
        })
    }

  }

  return (
    <div className="row">
      { }
      <div>
        {!reload &&
          <>
            {NotFoundData ?
              <NotFound /> :
              <div>
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10 form-view m-3">
                    <table>
                      <tbody>
                        <tr>
                          <td>Course Name :</td>
                          <td>{item.title.rendered}</td>
                        </tr>
                        <tr>
                          <td>Course Info :</td>
                          <td>{item.meta.course_short_desc}</td>
                        </tr>
                        <tr>
                          <td>Course ID : </td>
                          <td>{item.id}</td>
                        </tr>
                        <tr>
                          <td>Student Name : </td>
                          <td>{Login.userName}</td>
                        </tr>
                        <tr>
                          <td>Student ID : </td>
                          <td>{Login.userID}</td>
                        </tr>
                        <tr>
                          <td>Student Email : </td>
                          <td>{Login.userEmail}</td>
                        </tr>
                        <tr>
                          <td>Student Phone Number : </td>
                          <td>{Login.userPhoneNumber}</td>
                        </tr>
                        <tr>
                          <td>Course Price: </td>
                          <td>  Rs {item.meta.course_price} </td>
                        </tr>
                        <tr>
                          <td>Course Time: </td>
                          <td>{item.meta.course_time} hours</td>
                        </tr>
                        <tr>
                          <td>Course Resources: </td>
                          <td>{item.meta.total_resourses} (pdf and videos)</td>
                        </tr>
                        <tr>
                          <td>Course Type: </td>
                          <td>{item.meta.course_category} </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10 form-view m-3">
                    Orders Details:
                    {OrderData.length !== 0 &&
                      <table>
                        <tbody>
                          <tr>
                            <td>Amount</td>
                            <td>Paid</td>
                            <td>Status</td>
                            <td>Method</td>
                            <td>Date</td>
                            <td>ID</td>
                            <td></td>
                          </tr>

                          {OrderData.map((item, index) => (
                            <tr key={index}>
                              <td>Rs. {item.meta.amount_to_pay}</td>
                              <td>Rs. {item.meta.paid_amount}</td>
                              <td>{item.meta.verification_status}</td>
                              <td>{item.meta.verification_method}</td>
                              <td>{item.meta.verification_date}</td>
                              <td>{item.meta.verification_id.includes("https") ?
                                <div onClick={() => {
                                }}>
                                  <a href={item.meta.verification_id} target="_blank">
                                    image
                                  </a>
                                </div>
                                :
                                item.meta.verification_id
                              }</td>
                              <td>
                                {item.meta.verification_method !== "Manual" &&
                                  <>
                                    {item.meta.verification_status == "Unverified" &&
                                      <>
                                        {item.meta.amount_to_pay == CoursePrice &&
                                          <div className="sign-in-button-12"
                                            onClick={() => {
                                              PayNowHandle(item.id, item.meta)
                                            }}
                                          >
                                            Pay Now
                                          </div>
                                        }
                                      </>
                                    }
                                  </>
                                }
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    }
                    <br />
                    {(CoursePrice == "" || CoursePrice == "0") ?
                      <div>
                        <Link className=" Link" to={`${slugs.start_course}/${item.slug}`}>
                          <div className="sign-in-button-12 col-4"
                            onClick={() => { }}
                          >
                            Open Course
                          </div>
                        </Link>
                      </div>
                      :
                      <div>
                        {OrderData.filter(a => a.meta.verification_status == "Verified").length == 0 ?
                          <div className="sign-in-button-12 col-4"
                            onClick={() => { setNewPayment(true) }}
                          >
                            Pay to View Course
                          </div>
                          :
                          <div>
                            <Link className=" Link" to={`${slugs.start_course}/${item.slug}`}>
                              <div className="sign-in-button-12 col-4"
                                onClick={() => { }}
                              >
                                Open Course
                              </div>
                            </Link>
                          </div>
                        }

                      </div>
                    }
                    {OrderData.filter(a => a.meta.verification_status == "Verified").length == 0 &&

                      <>
                        {NewPayment &&
                          <table>
                            <tbody>
                              <tr>
                                <td>Course Cost : </td>
                                <td>Rs. {CoursePrice}</td>
                              </tr>
                              <tr>
                                <td>Payment Method : </td>
                                <td>
                                  <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"Esewa"}
                                    ImageUrl="https://api.dreamkoreaubttest.com/wp-content/uploads/2025/11/esewa.jpeg"
                                  />
                                  <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"Khalti"}
                                    ImageUrl="https://dao578ztqooau.cloudfront.net/static/img/logo1.png"
                                  />
                                  {/* <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"MyPay"}
                                ImageUrl="https://mypay.com.np/frontend/images/logo.png"
                              /> */}
                                  <CustomButton setData={setVerificationMethod} Data={VerificationMethod} DataValue={"Manual"} ImageUrl="" />
                                </td>
                              </tr>
                              {VerificationMethod == "Manual" &&
                                <tr>
                                  <td>Verification Image : </td>
                                  <td>
                                    <div className="col-12">
                                      <ImageUpload
                                        ImageUrl={VerificationID}
                                        setImageUrl={setVerificationID}
                                      />
                                      {VerificationID == "" &&
                                        "Attach slip"}
                                    </div>
                                  </td>
                                </tr>
                              }
                              <tr>
                                <td colSpan={2}>
                                  <div style={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
                                    {(VerificationID !== "" || VerificationMethod !== "Manual") &&
                                      <div className="sign-in-button-12 col-4"
                                        onClick={() => {
                                          BuyExamHandle()
                                        }}
                                      >
                                        Continue
                                        {VerificationMethod == "Esewa" && " with Esewa"}
                                        {VerificationMethod == "Khalti" && " with Khalti"}
                                        {VerificationMethod == "MyPay" && " with MyPay"}
                                      </div>
                                    }
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        }
                      </>
                    }
                  </div>
                </div>

                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10 form-view m-3">
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>Course Content</span>
                    <div style={{ border: "1px solid #bbb", margin: "10px", padding: "10px" }}>
                      {Object.values(JSON.parse(item.meta.content_preview)).map((item2, index) => (
                        <section style={{ padding: "2px" }} className="row"  >
                          <div style={{}} className="col-8">
                            <img style={{ width: 20 }} src="https://api.dreamkoreaubttest.com/wp-content/uploads/2023/11/play.jpeg" />
                            &nbsp; {item2.chapter_number} &nbsp;
                            {item2.title}
                          </div>
                          <div className="col-2" >
                            {item2.is_preview == "Free" &&
                              <div style={{ cursor: "pointer", textDecorationLine: "underline" }}
                                onClick={() => {
                                  setPreviewPressed(true)
                                  setPreviewType(item2.chapter_type)
                                  if (item2.chapter_type == "Video") {
                                    if (item2.youtube_id == "")
                                      setPreviewUrl(item2.video_link)
                                    else
                                      setPreviewUrl(`https://www.youtube.com/embed/${item2.youtube_id}`)
                                  }
                                  else if (item2.chapter_type == "PDF")
                                    setPreviewUrl(item2.pdf_url)
                                  else
                                    setPreviewUrl(item2.content)
                                }}
                              >
                                Preview
                              </div>
                            }
                          </div>
                          <div style={{}} className="col-2" >
                            {item2.time}

                          </div>
                        </section>
                      ))}
                    </div>

                    {PreviewPressed &&
                      <div className="modal">
                        <div className="row">
                          <div className="col-1" />
                          <div class="modal-dialog" role="document" className="col-10">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">{item.title.rendered}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                  onClick={() => { setPreviewPressed(false) }}
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <div style={{ minHeight: "78vh", overflowY: "scroll" }}>
                                  {PreviewType == "PDF" &&
                                    <iframe
                                      style={{ width: "100%", height: "80vh" }}
                                      src={PreviewUrl}></iframe>
                                  }
                                  {PreviewType == "Video" &&
                                    <>
                                      <iframe
                                        style={{ width: "100%", height: "78vh" }}
                                        src={PreviewUrl}>
                                      </iframe>
                                    </>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>

                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10 form-view m-3">
                    {Object.values(JSON.parse(item.meta.requirements)).length !== 0 &&
                      <div style={{ margin: "20px 0" }}>
                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>Requirements</span>
                        <div style={{ border: "1px solid #bbb", margin: "10px", padding: "10px" }}>
                          {Object.values(JSON.parse(item.meta.requirements)).map((item2, index) => (
                            <section style={{ padding: "2px" }} className="row"  >
                              <div style={{}} className="col-8">
                                <i className="fa fa-check" />
                                &nbsp; {item2} &nbsp;
                              </div>
                            </section>
                          ))}
                        </div>
                      </div>
                    }
                    {Object.values(JSON.parse(item.meta.what_will_you_learn)).length !== 0 &&
                      <div style={{ margin: "20px 0" }}>
                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>What will you Learn</span>
                        <div style={{ border: "1px solid #bbb", margin: "10px 10px 20px", padding: "10px" }}>
                          {Object.values(JSON.parse(item.meta.what_will_you_learn)).map((item2, index) => (
                            <section style={{ padding: "2px" }} className="row"  >
                              <div style={{}} className="col-8">
                                <i className="fa fa-check" />
                                &nbsp; {item2} &nbsp;
                              </div>
                            </section>
                          ))}
                        </div>
                      </div>
                    }
                    {Object.values(JSON.parse(item.meta.who_is_this_course_for)).length !== 0 &&
                      <div style={{ margin: "20px 0" }}>
                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>Who is this course For</span>
                        <div style={{ border: "1px solid #bbb", margin: "10px 10px 20px", padding: "10px" }}>
                          {Object.values(JSON.parse(item.meta.who_is_this_course_for)).map((item2, index) => (
                            <section style={{ padding: "2px" }} className="row"  >
                              <div style={{}} className="col-8">
                                <i className="fa fa-check" />
                                &nbsp; {item2} &nbsp;
                              </div>
                            </section>
                          ))}
                        </div>
                      </div>
                    }
                    {item.meta.description.length !== 0 &&
                      <div style={{ margin: "20px 0" }}>
                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>Description</span>
                        <div style={{ border: "1px solid #bbb", margin: "10px 10px 20px", padding: "10px" }}>
                          {item.meta.description}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </>
        }
        {ResetFreeCourse &&

          <section className="modal" >
            <div className="row">
              <div className="col-md-4 col-1"></div>
              <div className="col-md-4 col-10  shadow bg-white">
                <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                  <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                    onClick={() => {
                      setResetFreeCourse(false)

                    }}
                  >X</div>
                  Do you really want to reset the Course?<br />
                  Resetting exCourseam is irreversible.
                  <tr>
                    <td colSpan={6}>
                      <div className="row">
                        <div className="col-1" />
                        <div className="col-5 center " >
                          <div className="sign-in-button-4" style={{ width: "80%" }}
                            onClick={() => {
                              setResetFreeCourse(false)
                            }}
                          >
                            Cancel
                          </div>
                        </div>
                        <div className="col-5 center">
                          <div className="sign-in-button-4" style={{ width: "80%" }}
                            onClick={() => {
                              ResetCourseComp(ResetFreeExamID)
                              setResetFreeCourse(false)
                            }}
                          >
                            Reset Now
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </div>
              </div>
            </div>
          </section>

        }
        {/* <form ref={myform} action="https://esewa.com.np/epay/main" method="POST"> */}
        <form ref={myform} action="https://uat.esewa.com.np/epay/main" method="POST">
          <input value={CoursePrice} name="tAmt" type="hidden" />
          <input value={CoursePrice} name="amt" type="hidden" />
          <input value="0" name="txAmt" type="hidden" />
          <input value="0" name="psc" type="hidden" />
          <input value="0" name="pdc" type="hidden" />
          {/* <input value="NP-ES-DREAMKOREAN" name="scd" type="hidden" /> */}
          <input value="EPAYTEST" name="scd" type="hidden" />
          <input value={pid} name="pid" type="hidden" />
          <input value={`http://localhost:3000/course_payment/${OrderID}?buy=${BuyNow}&exam=${location.pathname.slice(slugs.course_payment.length + 1)}`} type="hidden" name="su" />
          {/* <input value={`https://exam.dreamkoreansmartclass.com/course_payment/${OrderID}?buy=${BuyNow}&exam=${location.pathname.slice(slugs.course_payment.length + 1)}`} type="hidden" name="su" /> */}
          <input value={`https://localhost:3000${location.pathname}`} type="hidden" name="fu" />
          {/* <input value={`https://exam.dreamkoreansmartclass${location.pathname}`} type="hidden" name="fu" /> */}
        </form>

        {reload &&
          <div className="modal" style={{ padding: "50vw" }}>
            <div className="dot-pulse"></div>
          </div>
        }
      </div >
    </div >
  )
}
